import { rem } from '@/theme'
import styled from 'styled-components'

const InterimRechartsStyle = styled.div`

	${({ theme }) => theme.align_center};
	background: ${({ theme }) => theme.con_bg};
	border: 1px solid ${({ theme }) => theme.gray100};
	div.text-module {
		position: relative;
	}

	// PC
	@media screen and (min-width: 540px) { 
		height: 269px;
		padding: 20px;
		border-radius: 24px;
		div.text-module {
			margin-top: 5px;
			left: -30px;
		}
	}

	// H5
	@media screen and (max-width: 540px) {
		height: ${rem(220)};
		padding: ${rem(16)};
		margin-top: ${rem(16)};
		border-radius: ${rem(16)};
		& > div {
			div.text-module {
				margin-top: ${rem(5)};
				left: ${rem(-25)};
			}
		}
	}
`

export {
	InterimRechartsStyle,
}